import { render, staticRenderFns } from "./config-provider-torrent.vue?vue&type=template&id=66655510&"
import script from "./config-provider-torrent.vue?vue&type=script&lang=js&"
export * from "./config-provider-torrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports